import { CollaboratorService } from './../../../rest/api/collaborator.service';
import { HelperService } from './../../../services/helper.service';
import { AuthService } from './../../../services/auth.service';
import { Component, OnInit, Input, SimpleChanges, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'app-space-invite-collaborator',
  templateUrl: './space-invite-collaborator.component.html',
  styleUrls: ['./space-invite-collaborator.component.scss']
})
export class SpaceInviteCollaboratorComponent implements OnInit, OnChanges {
  @ViewChild('selectedEmail') selectedEmail: ElementRef;
  @Input() singleSpaceData;
  @Input() collaboratorsData;
  accessToken: any;
  spaceInviteCollaboratorForm: FormGroup;
  isSubmitting = false;
  isSubmitted = false;
  errors = [];
  successMsg: string;
  errorMsg: string;
  loadingCollab = true;

  activeCollaborators: any;
  filteredCollaborators: any;
  selectedMemberId: string;
  showListFilter = false;

  constructor(
    public fb: FormBuilder,
    private authService: AuthService,
    public helperService: HelperService,
    public collaboratorService: CollaboratorService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.collaboratorsData && changes.collaboratorsData.currentValue) {
      this.filteredCollaborators = this.collaboratorsData;
      this.loadingCollab = true;
    }
  }

  ngOnInit() {
    this.spaceInviteCollaboratorFormInit();
  }

  spaceInviteCollaboratorFormInit() {
    this.spaceInviteCollaboratorForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      role: ['view', [Validators.required]],
    });
  }

  submit(value) {
    if (!this.spaceInviteCollaboratorForm .valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    this.spaceInviteCollaboratorDetail(data);
  }

  resetErrors() {
    this.successMsg = undefined;
    this.errorMsg = undefined;
    this.errors = [];
  }

  spaceInviteCollaboratorDetail(data) {
    const collaboratorFind = _.find(this.collaboratorsData, {email: data.email});
    if (!collaboratorFind) {
      this.errorMsg = 'Collaborators was not found.';
      return;
    }
    const formData = {
      email: data.email,
      role: data.role,
      member_id: collaboratorFind.member,
      space_id : this.singleSpaceData.uuid
    };

    data = this.helperService.updateJsonFormat(formData);
    this.collaboratorService.spaceInviteCollaborator({
      Authorization: this.accessToken,
      body: data
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'Role has been assigned to collaborator.';
      setTimeout(() => {
        this.resetErrors();
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.spaceInviteCollaboratorForm.reset({ role: 'view', email: ''});
  }

  handleErrors(err) {
    if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errors = err.error.errors;
    } else if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while assigning role to collaborator.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 2000);
  }

  filterCollaborator(value) {
    if (value) {
      this.filteredCollaborators = _.filter(this.collaboratorsData, (res) => {
        const email = res.email;
        return email.indexOf(value) > 0;
      });
    } else {
      this.filteredCollaborators = [];
    }
  }

  showDiv() {
    this.showListFilter = true;
  }

  hideDiv() {
    this.showListFilter = false;
  }

}

